class BaseResponseJson {
  constructor(success, message, code, data, page, errorCode) {
    this.success = success;
    this.message = message;
    this.code = code;
    this.data = data;
    this.page = page;
    this.errorCode = errorCode;
  }
}

export default BaseResponseJson;
